<template>
  <!-- @click.prevent.stop="mockBuy()" -->
  <!-- https://ramptest.alchemypay.org?appId=jcudotl1hwyvxhdp&email=test@alchemytech.io&crypto=BTC&network=bitcoin&address=xxxxxxx&redirectURL=xxx&noticeUrl=xxx -->
  <a class="coin_link" id="coin_buy_btn" :href="purchaseUrl" target="_blank">
    <div class="icon-alchemypay"></div>
  </a>
</template>

<script>
import { postPayRamppage } from '@/api/user'

export default {
  props: {
    callbackUrl: String,
    usdt: Number,
    title: { type: String, default: '购买USDT' }
  },
  data() {
    // getAvatarList().then(res => {
    //   this.img = getAvatarListMock();
    // });
    return {
      // API_KEY: 'f83Is2y7L425rxl8',
      // API_KEY: 'pk_test_L7lXJcjBuMgdrIbAwtY0Vd5VP1x4Crpni2HxdrGlEmU',
      TOKEN: 'USDT:TXQCDLvVawZvZ14ixPdEDiN7QsDDAFtWiL',
      BUY_BASE_URL: 'https://ramptest.alchemypay.org?',
      callback: null,
      purchaseUrl: '#'
    }
  },
  mounted() {
    postPayRamppage().then((_) => {
      // window.open(_.data.url, '_blank')
      this.purchaseUrl = _.data.url
    })
  },
  methods: {
    mockBuy() {
      postPayRamppage().then((_) => {
        window.open(_.data.url, '_blank')
      })
    },
    partnerContext() {
      return encodeURI(
        JSON.stringify({
          myUserId: localStorage.getItem('user_id')
        })
      )
    }
  }
}
</script>
<style lang="scss">
.coin_link {
  width: auto;
  display: inline-block;
  border-radius: 0.04rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CoinCharge.vue